import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

export default function DemographicInfoDisplay(props) {
  const { value, label, enumsPeopleArray } = props;

  if (value && label) {
    const enumsPeopleType = _.find(enumsPeopleArray, { value });
    return (
      <div className="demographic-info-display">
        <p><span className="strong">{label}:</span> {enumsPeopleType.display_name}</p>
      </div>
    );
  }
  return null;
}

DemographicInfoDisplay.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  enumsPeopleArray: PropTypes.array.isRequired,
};
